<template>
  <div
    ref="previewFooterScroller"
    class="preview-footer-scroller"
  >
    <!--文件列表提示部分（loading和error）-->
    <div
      v-show="!isLoadSuc"
      class="scroller-tip"
    >
      <span
        v-if="isLoadFail && lang !== 'en'"
        class="error-tip"
      >{{ $t('加载失败') }}<span
        class="refresh"
        @click="reloadFileList"
      >{{ $t('刷新') }}</span>{{ $t('重试') }}</span>
      <span
        v-else-if="isLoadFail && lang==='en'"
        class="error-tip"
      >List load failed, please<span
        class="refresh"
        @click="reloadFileList"
      >refresh</span></span>
      <span
        v-else
        class="load-icon"
      />
    </div>
    <!--左边翻页-->
    <div
      class="preview-control preview-pre"
      :style="{width: scrollerSectionSideWidth}"
    >
      <svg
        v-show="hasPre"
        class="item-icon"
        @click="stepTo('left')"
      >
        <use xlink:href="#previousPage" />
      </svg>
    </div>
    <!--右边翻页-->
    <div
      class="preview-control preview-next"
      :style="{width: scrollerSectionSideWidth}"
    >
      <svg
        v-show="hasNext"
        class="item-icon"
        @click="stepTo('right')"
      >
        <use xlink:href="#nextPage" />
      </svg>
    </div>
    <!--中间文件列表-->
    <section
      class="scroller-section"
      :style="{width: scrollerSectionWidth, left: scrollerSectionSideWidth}"
    >
      <div
        ref="scrollerContent"
        v-mousewheel="stepTo"
        :class="['scroller-content', !balanceX? 'transition-move':'']"
        :style="{ transform: `translate3d(${translateX}px, 0, 0)`}"
      >
        <div
          v-show="hasPre && loadData"
          class="header"
        >
          <slot name="loading">
            <div class="header-loading">
              {{ $t('加载中') }}
            </div>
          </slot>
        </div>
        <div
          v-for="(item, i) in scrollerData"
          ref="scrollerContentBox"
          :key="i"
          :class="['scroller-content-box', (item.fileindex === selectedItem.fileindex ? 'focusOn':'')]"
          @click="selectItem(i, item)"
        >
          <div class="scroller-content-poster">
            <svg
              v-if="!imageCanPreview(item) && !item.is_deleted"
              class="poster-icon"
            >
              <use :xlink:href="`#${getFileIcon(item)}`" />
            </svg>
            <img
              v-if="item.is_deleted"
              src="./images/typeIcon/deleted.svg"
              class="poster-icon"
              alt="icon">
            <img
              v-if="imageCanPreview(item)"
              ref="scrollerContentBoxPic"
              src="./images/blue-loading.gif"
              :data-src="getPicRouter(item)"
              alt="icon"
              class="poster-icon"
              @load="getPicSuc($event)"
              @error="getPicFail(item, $event)"
            >
          </div>
          <co-tips
            refs="coTips"
            :disabled="disableTip"
            :content="getTitle(item.path)"
            placement="top"
          >
            <span class="scroller-content-title">{{ getTitle(item.path) }}</span>
          </co-tips>
        </div>
        <div
          v-show="hasNext && loadData"
          class="footer"
        >
          <slot name="loading">
            <div class="footer-loading">
              {{ $t('加载中') }}
            </div>
          </slot>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import * as Util from 'js/util/util'
import coTips from 'components/common/tips/index.vue'

const picSrc = require('./images/typeIcon/pic.svg') // 引入js所需的图片icon

export default {
  components: {
    coTips,
  },
  directives: {
    mousewheel: {
      inserted(el, binding, vnode) {
        const vm = vnode.context // vnode.context存着上下文
        vm.mousewheel(el, binding.value)
      },
    },
  },
  props: {
    frameConfig: { // 预览小框的宽高，边距等
      type: Object,
      default: () => ({
        frameWidth: 120,
        frameSpaceEach: 12,
        frameSpaceSide: 60,
        rightAreaWidth: 300,
      }),
    },
    isShow: { // 是否显示
      type: Boolean,
      default: false,
    },
    isShowRight: { // 是否显示右侧
      type: Boolean,
      default: false,
    },
    reqParam: { // 请求当前文件列表的参数
      type: Object,
      default: () => ({}),
    },
    step: { // 记录点击上一个下一个
      type: Number,
      default: 0,
    },
    isDelivery: { // 是否是外链里的底部列表
      type: Boolean,
      default: false,
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    selectedIndex: {
      type: Number,
    },
  },
  data() {
    return {
      fileListInfo: {}, // response
      scrollerSectionWidth: 0, // 滚动区域的可视宽度
      scrollerSectionSideWidth: 0, // 滚动区域两边留白的宽度
      curIndex: 0, // 当前预览文件所在的相对位置
      frameNum: 0, // 当前页面最多放frameNum个小框
      translateX: 0, // 文件列表在X轴移动距离
      balanceX: false, // 用于中和translateX的动画效果， false为加动画
      hasNext: false, // 是否还存在向右翻页
      hasPre: false, // 是否还存在向左翻页
      startIndex: -1, // 可视区域的start下标
      endIndex: -1, // 可视区域的end下标
      isLoadSuc: false, // 加载成功
      isLoadFail: false, // 加载失败
      loadData: false, // 是否正在请求数据
      selectedItem: {}, // 选中的文件的数据
      totalLen: 0, // 总列表长度
      direction: '', // 左右翻页的标准，用于阻止startIndex变化造成的自动请求下屏或上屏
      selectLabel: false, // 点击的标志，用于阻止startIndex变化造成的自动请求下屏或上屏
      nextScreen: '', // 记录分段加载是否是翻页触发
      nextSelectLabel: false, // 记录分段加载是否是点击触发
      disableTip: false, // element Tooltip 是否可用
    }
  },
  computed: {
    scrollerData() {
      const fileList = this.fileListInfo.content || [] // 获取文件列表数据，Array形式
      // if (fileList.length <= 0) return;
      this.totalLen = this.fileListInfo.filecount
      const curRelativeIndex = this.findInLoop(fileList, 'fileindex', this.fileListInfo.fileindex)
      this.curFileIndex = curRelativeIndex < 0 ? 0 : curRelativeIndex // 获取当前文件的位置，注意下标从0开始
      this.curIndex = this.curFileIndex
      return fileList
    },
    /**
         * 是否可以预览，用于图片是否请求略缩图
         */
    canPreview() {
      const { canPreview } = Util.getPrivatePrivilege(Util.resolveFileAction(this.fileListInfo.access_mode))
      return this.fileListInfo.access_mode && canPreview
    },
    // 判断当前语言
    lang() {
      return Util.getLanguage()
    },
  },
  watch: {
    /**
         * 监听请求参数变化
         */
    reqParam(val, oldVal) {
      if (JSON.stringify(val) == '{}') return
      this.selectedItem = {}
      this.startIndex = -1
      this.endIndex = -1
      const { getRangeData, selectedItem } = this
      this.$emit('load', { reqParam: val, getRangeData, selectedItem })
    },
    selectedIndex(fileindex) {
      this.selectItem(fileindex, this.fileListInfo.content[fileindex])
    },
    /**
         * 监听文件列表数据变化
         */
    scrollerData: {
      immediate: true,
      handler(val) {
        if (this.isShow) {
          if (!val.length) return
          this.setScrollerSectionWidth()
          this.initializePos()
        }
      },
    },
    /**
         * 监听文件列表显示，prop
         */
    isShow(val, oldVal) {
      if (val) {
        this.$nextTick(() => {
          this.translateX = 0
          this.nextScreen = ''
          this.listener('add')
          if (this.scrollerData) {
            if (!this.scrollerData.length) return
            this.setScrollerSectionWidth()
            this.initializePos()
          }
        })
      } else {
        this.listener('remove')
        // 关闭文件列表时，如果当前文件在当屏数据中不存在，则去请求
        const neidExist = this.findInLoop(this.scrollerData, 'neid', this.$route.params.neid)
        if (this.reqParam.neid !== this.$route.params.neid && neidExist < 0) {
          this.reqParam.neid = this.$route.params.neid
          const { reqParam, getRangeData, selectedItem } = this
          if (JSON.stringify(reqParam) == '{}') return
          this.$emit('load', { reqParam, getRangeData, selectedItem })
        }
      }
    },
    /**
         * 监听右侧栏显示，prop
         */
    isShowRight(val, oldVal) {
      if (this.isShow && this.scrollerData && !this.isFullScreen) {
        this.$nextTick(() => {
          this.setScrollerSectionWidth('resize') // resize参数，当resize的时候，底部列表的可视区域(从startIndex到endIndex)区域动态变化
        })
      }
    },
    /**
         * 是否是全屏时
         */
    isFullScreen(val) {
      this.$nextTick(() => {
        this.setScrollerSectionWidth('resize') // // resize参数，当resize的时候，底部列表的可视区域(从startIndex到endIndex)区域动态变化
      })
    },
    /**
         * 监听startIndex变化，来决定是否可以请求下/上一屏数据
         */
    startIndex(val, oldVal) {
      this.reqPicUrl(val + this.frameNum); // 请求当前屏的图片
      // 是否存在左右翻页
      [this.hasPre, this.hasNext] = this.checkReachEnd()
      // console.log('val, curIndex, 请求标志=', val, this.scrollerData[val] && this.scrollerData[val].path, this.curIndex, this.selectLabel, this.direction)
      // direction和selectLabel是可以请求下/上屏的标志; 只有按了翻页或点击新数据，才有可能触发请求下一屏/上一屏数据的逻辑
      // direction为right/left表示，用户按了右/左翻页
      // selectLabel为true表示，用户点击了某一个数据
      if (!this.direction && !this.selectLabel) return
      const TIMES = 1 // 距离几屏时开始下次请求
      let reqItem = {} // 要请求的节点
      const size = this.scrollerData.length // 当前数据列表长度
      const reqParamParsed = { ...this.reqParam } // reqParam的修饰,外链里和预览里不同
      const { getRangeData, selectedItem } = this
      // 记录请求由点击触发，等请求回来，通过它定位列表如何滚动
      this.nextnextSelectLabel = this.selectLabel
      // 记录请求由翻页触发，等请求回来，通过它来定位列表如何滚动
      this.nextScreen = ''
      // 底下的if - else 用来判断是否能请求下/上屏数据
      // if判断 距底部是否小于设定的个数(size - val <= TIMES)，是否向下一屏请求(val > oldVal), 是否有右翻页按钮(this.hasNext), 是否有下一屏(this.scrollerData[size - 1].fileindex < this.totalLen - 1)
      // else判断 距首部是否小于设定的个数(val <= TIMES * this.frameNum)，是否向上一屏请求(val < oldVal), 是否有左翻页按钮(this.hasPre), 是否有上一屏(this.scrollerData[0].fileindex > 0)
      if (size - val <= TIMES * this.frameNum && val > oldVal && this.hasNext && this.scrollerData[size - 1].fileindex < this.totalLen - 1) {
        if (!this.loadData) {
          this.loadData = true // 请求还未回来，不再重复请求下屏
          if (this.selectLabel) {
            this.balanceX = true // 取消tansformX的动画，GYRHQA-3495，不然切换数据时，滚动太明显
            reqItem = this.scrollerData[size - 1] || {}
            this.decorateReqParam(reqParamParsed, reqItem) // 修改请求参数
            this.$emit('load', { reqParam: reqParamParsed, getRangeData, selectedItem })
            console.log('请求下一屏-click', val, reqItem.fileindex, reqItem.path, reqParamParsed)
            return
          }
          this.nextScreen = 'right' // 记录请求由右翻页触发
          // console.log('next screen---right', this.startIndex, this.endIndex, this.scrollerData[val])
          reqItem = this.scrollerData[val] || {}
          this.decorateReqParam(reqParamParsed, reqItem) // 修改请求参数
          this.$emit('load', { reqParam: reqParamParsed, getRangeData, selectedItem })
          console.log('请求下一屏-翻页>>', val, reqItem.fileindex, reqItem.path, reqParamParsed)
        }
      } else if (val <= TIMES * this.frameNum && val < oldVal && this.hasPre && this.scrollerData[0].fileindex > 0) {
        if (!this.loadData) {
          this.loadData = true
          if (this.selectLabel) {
            this.balanceX = true // 取消tansformX的动画
            reqItem = this.scrollerData[0] || {}
            this.decorateReqParam(reqParamParsed, reqItem) // 修改请求参数
            this.$emit('load', { reqParam: reqParamParsed, getRangeData, selectedItem })
            console.log('请求上一屏-click', val, reqItem.fileindex, reqItem.path, reqParamParsed)
            return
          }
          this.nextScreen = 'left'
          // console.log('next screen---left', this.startIndex, this.endIndex, oldVal, this.scrollerData[val], this.scrollerData[this.endIndex])
          reqItem = this.scrollerData[val] || {}
          this.decorateReqParam(reqParamParsed, reqItem) // 修改请求参数
          this.$emit('load', { reqParam: reqParamParsed, getRangeData, selectedItem })
          console.log('请求上一屏-翻页<<', val, reqItem.fileindex, reqItem.path, reqParamParsed)
        }
      }
    },
    /**
         * 监听翻页，prop
         */
    step(val, oldVal) {
      if (val > oldVal) {
        this.selectItem(this.curIndex + 1)
      } else {
        this.selectItem(this.curIndex - 1)
      }
    },
  },
  mounted() {
    const { reqParam, getRangeData, selectedItem } = this
    if (JSON.stringify(reqParam) == '{}') return
    this.$emit('load', { reqParam, getRangeData, selectedItem })
  },
  methods: {
    imageCanPreview(item) {
      return Util.ifHasAuth(item.access_mode, 'preview') && item.support_preview === 'true' && item.mime_type.includes('image')
    },
    /**
         * 是否还可以进行翻页操作
         * @ return {Array} 是否可以向前翻页，向后可以向后翻页
         */
    checkReachEnd() {
      // size为当前请求的数据总条数，totalLen为总数居条数
      // startPoint：可视区域(this.startIndex到this.endIndex)第一位在总数据中的位置
      // endPoint：可视区域最后一位在总数据中的位置。
      // 可视区域下标从0到7（即一屏8个），下标为0的数据在总数居中的位置为24(接口字段fileindex)，那startPonit为24，endPoint为31
      const size = this.scrollerData.length
      let hasPre = false
      let hasNext = false
      const startPoint = (this.scrollerData[this.startIndex] && this.scrollerData[this.startIndex].fileindex) || 0
      const endPoint = (this.scrollerData[this.endIndex] && this.scrollerData[this.endIndex].fileindex) || 0
      if (startPoint >= 1) hasPre = true
      if (size != this.frameNum && endPoint < this.totalLen - 1) hasNext = true
      // console.log('checkEnd===', [hasPre, hasNext])
      return [hasPre, hasNext]
    },
    /**
         * 获取当前选中的文件
         * 有selectedItem（选中的文件）,就获取它的neid和其定位；
         * 没有selectedItem，则从请求数据（fileListInfo,fileListInfo的content属性对应scrollerData）中获取fileindex对应的neid和其定位
         * @ return {Number} 当前选中文件的下标，没有选中返回-1
         */
    getCurIndex() {
      const curNeid = (this.selectedItem && this.selectedItem.neid) || (this.scrollerData[this.curFileIndex] && this.scrollerData[this.curFileIndex].neid)
      let curIndex = -1 // 相对定位，在50条数据中的位置，存在时，下标从0到49
      const selectedIndex = JSON.stringify(this.selectedItem) !== {} ? this.selectedItem.fileindex : this.fileListInfo.fileindex // 绝对定位
      // console.log('getCurIndex---', curNeid, this.reqParam, this.selectedItem, this.fileListInfo)
      curIndex = this.findInLoop(this.scrollerData, 'neid', curNeid)
      if (curIndex === -1 && (selectedIndex < this.scrollerData[0].fileindex || selectedIndex > this.scrollerData[this.scrollerData.length - 1].fileindex)) {
        // console.log('当前选中不在此数据段中-')
        // 当前选中不在此数据段中 e.g.即当前选中了第1条，但是滚动列表展示的是第51条，到100条
        // this.afterDeleteOp(this.selectedItem.fileindex)
      } else if (curIndex === -1) {
        // 删除了
        const data = {
          srcFolderExist: false,
          selectedData: this.selectedItem,
          fn: () => {
            this.afterDeleteOp()
          },
        }
        this.$emit('deleteFileItem', data)
      }
      // console.log('getCurIndex item---', curIndex, this.selectedItem)
      return curIndex
    },
    /**
         * 当删除后，进行加载下一个或上一个或刷新列表的操作
         * @param {Number} inx 当前选中的数据的fileindex，即当前数据的绝对位置
         */
    afterDeleteOp(inx) {
      const index = inx || this.selectedItem.fileindex
      const fileList = this.scrollerData || []
      const curRelativeIndex = this.findInLoop(fileList, 'fileindex', index) // 把当前数据绝对fileindex转化为其在scrollData里的相对定位
      const nextOne = curRelativeIndex + 1
      const preOne = curRelativeIndex - 1
      // console.log('------selected-------', index, curRelativeIndex, this.selectedItem, this.scrollerData[nextOne],  this.scrollerData[preOne])
      if (this.scrollerData[nextOne]) {
        this.selectedItem = this.scrollerData[nextOne] // 选中下一个，显示蓝框
        this.$emit('getSelectedData', this.scrollerData[nextOne])
      } else if (this.scrollerData[preOne]) {
        this.selectedItem = this.scrollerData[preOne] // 选中上一个，显示蓝框
        this.$emit('getSelectedData', this.scrollerData[preOne])
      } else {
        this.$emit('getSelectedData', {})
      }
      this.initializePos() // 定位当前文件的位置
    },
    /**
         * 获取数据后，定位当前文件的位置
         * 分为3种情况：
         * 1、列表中无当前选中数据，那只需要滚动列表到合适位置
         * 2、选中的数据位于列表的“可视区域半屏”之前，那只需要定位选中蓝框，不需要滚动列表
         * 3、选中数据位于列表的“可视区域半屏”之后，那就需要滚动列表，把当前选中定位到可视区域中间
         */
    initializePos() {
      const middleIndex = this.getMiddleFramePos()
      const size = this.scrollerData.length
      const curIndex = this.getCurIndex()
      this.curIndex = curIndex
      // console.log('initializePos-curIndex-nextScreen-', this.curIndex, this.nextScreen)
      if (this.curIndex < 0) { // 文件列表中无当前选中的数据
        // console.log('this.curIndex < 0', this.curFileIndex, this.scrollerData[this.curFileIndex])
        if (this.nextScreen && !this.nextSelectLabel) { // 由翻页触发的请求，等数据回来后的定位
          this.posNextScreen()
        } else {
          this.scrollFileList(this.curFileIndex, false)
        }
      } else if (this.curIndex <= middleIndex - 1) { // 不需移动数据列表
        // console.log('this.curIndex <= middleIndex - 1', this.curIndex)
        if (this.nextScreen && !this.nextSelectLabel) { // 由翻页触发的请求
          this.posNextScreen()
        } else {
          this.selectedItem = this.scrollerData[this.curIndex]
          this.startIndex = this.curIndex - (middleIndex - 1) <= 0 ? 0 : this.curIndex - (middleIndex - 1)
          this.endIndex = this.startIndex + this.frameNum - 1 >= size ? size - 1 : this.startIndex + this.frameNum - 1
          this.translateX = 0
          // console.log('点击-', this.startIndex, this.endIndex)
          this.selectItem(this.curIndex)
        }
      } else {
        this.selectedItem = this.scrollerData[this.curIndex]
        // console.log('列表需滚动', this.translateX)
        if (this.nextScreen && !this.nextSelectLabel) { // 由翻页触发的请求
          this.posNextScreen()
        } else {
          // console.log('点击-',this.curIndex)
          this.selectItem(this.curIndex)
        }
      }
    },
    /**
         * 由左右翻页引起的分段加载，得到数据后的定位
         */
    posNextScreen() {
      const FRAME_WIDTH = this.frameConfig.frameWidth + this.frameConfig.frameSpaceEach // 120+12
      this.balanceX = true // 取消tanslateX的动画，GYRHQA-3495
      this.translateX = -this.curFileIndex * FRAME_WIDTH
      this.startIndex = this.curFileIndex
      this.endIndex = this.startIndex + this.frameNum
    },
    /**
         * 滚轮事件
        */
    mousewheel(element, callback) {
      if (element && element.addEventListener) {
        element.addEventListener('mousewheel', function (event) {
          const e = event
          let direction
          if (e.wheelDelta) {
            if (e.wheelDelta > 0) { // 当鼠标滚轮向上滚动时
              direction = 'left'
            }
            if (e.wheelDelta < 0) { // 当鼠标滚轮向下滚动时
              direction = 'right'
            }
          } else if (e.detail) {
            if (e.detail < 0) { // 当鼠标滚轮向上滚动时
              direction = 'left'
            }
            if (e.detail > 0) { // 当鼠标滚轮向下滚动时
              direction = 'right'
            }
          }
          callback && callback.call(this, direction)
        })
      }
    },
    /**
         * 键盘左右建移动
         */
    keyBoardOperation(e) {
      switch (e.keyCode) {
        case 37: // left
          this.selectItem(this.curIndex - 1, this.scrollerData[this.curIndex - 1])
          break
        case 39: // right
          this.selectItem(this.curIndex + 1, this.scrollerData[this.curIndex + 1])
          break
      }
    },
    /**
         * 计算左右翻页的startIndex，endIndex和translateX(列表移动距离)
         */
    calcStepTo(direction) {
      const FRAME_WIDTH = this.frameConfig.frameWidth + this.frameConfig.frameSpaceEach // 120+12
      const [startIndex, endIndex] = [this.startIndex, this.endIndex]
      const { frameNum } = this
      const size = this.scrollerData.length
      if (direction === 'right') {
        if (size - 1 - endIndex >= 0 && size - 1 - endIndex <= frameNum) {
          this.translateX = this.loadData ? (endIndex - (frameNum - (size - endIndex)) + 1) * -FRAME_WIDTH : (endIndex - (frameNum - (size - endIndex))) * -FRAME_WIDTH
          this.endIndex = size - 1
          this.startIndex = this.endIndex - (frameNum - 1)
        } else {
          this.translateX = endIndex * -FRAME_WIDTH
          this.startIndex = this.endIndex
          this.endIndex = this.startIndex + frameNum - 1 >= size ? size - 1 : this.startIndex + frameNum - 1
        }
      } else if (direction === 'left') {
        if (startIndex <= frameNum) {
          this.translateX = this.loadData ? FRAME_WIDTH : 0
          this.startIndex = 0
          this.endIndex = this.startIndex + frameNum - 1 >= size ? size - 1 : this.startIndex + frameNum - 1
        } else {
          this.translateX = (startIndex - (frameNum - 1)) * -FRAME_WIDTH
          this.endIndex = this.startIndex
          this.startIndex = this.endIndex - (frameNum - 1) <= 0 ? 0 : this.endIndex - (frameNum - 1)
        }
      }
    },
    /**
         * 翻页，即整行向右或左移动
         * @params {String} direction 移动方向 'right' or 'left'
         */
    stepTo(direction) {
      this.selectLabel = false // 翻页时，把点击选择的标志置为false
      this.balanceX = false // 让tanslateX的动画有效
      this.debounce(function () { // 防抖，间隔0.4s
        if (direction === 'right' && this.hasNext) { // 点击右翻页
          this.direction = 'right' // 此变量会在请求下一屏用到(watch中的startIndex)
          this.calcStepTo(this.direction)
        } else if (direction === 'left' && this.hasPre) {
          this.direction = 'left'
          this.calcStepTo(this.direction)
        }
      })
    },
    /**
         * 监听键盘，窗口变化事件
         */
    listener(flag) {
      const vm = this
      if (flag === 'add') {
        window.addEventListener('resize', () => {
          vm.setScrollerSectionWidth('resize') // resize参数，当resize的时候，底部列表的可视区域(从startIndex到endIndex)区域动态变化
        })
        document.body.addEventListener('keyup', vm.keyBoardOperation, false)
      } else if (flag === 'remove') {
        window.removeEventListener('resize', vm.setScrollerSectionWidth)
        document.body.removeEventListener('keyup', vm.keyBoardOperation, false)
      }
    },
    /**
         * 设置底部收缩框中的展示小框的个数
         * @returns {Number} 可视区域的小框数
         */
    setScrollFrameNum() {
      const footerContainerWidth = document.body.clientWidth - (this.isShowRight ? this.frameConfig.rightAreaWidth : 0) // 底部收缩框的宽度
      let frameNum = Math.floor((footerContainerWidth - this.frameConfig.frameSpaceSide * 2) / (this.frameConfig.frameWidth + this.frameConfig.frameSpaceEach))
      if (this.scrollerData && this.scrollerData.length > 0 && this.scrollerData.length < frameNum) { // 待续
        frameNum = this.scrollerData.length
      }
      return frameNum
    },
    /**
         * 设置底部收缩框中的展示条宽度
         */
    setScrollerSectionWidth(label) {
      const frameNum = this.setScrollFrameNum()
      const footerContainerWidth = document.body.clientWidth - (this.isShowRight ? this.frameConfig.rightAreaWidth : 0) // 底部收缩框的宽度
      const scrollerSectionWidth = frameNum * (this.frameConfig.frameWidth + this.frameConfig.frameSpaceEach)
      this.scrollerSectionWidth = `${scrollerSectionWidth - this.frameConfig.frameSpaceEach}px` // 后续要改unit
      this.scrollerSectionSideWidth = `${(footerContainerWidth - scrollerSectionWidth) / 2}px` // 后续要改unit
      this.frameNum = frameNum
      if (label === 'resize') { // 解决 GYRHQA-3413预览文件列表的最后几个，当右侧栏展开，会留空白
        this.scrollFileList(this.curIndex)
      }
    },
    /**
         * 选中小框新开页预览
         * @param {Number} i 当前选中的数据的相对位置(e.g. i=3代表50个数据中的第4个,下标从0开始);可通过下标，获取当前选中数据(同item参数)
         * @param {Object} item 当前选中的数据，只有鼠标点击某个文件或者键盘左右键选中某个文件，才会传递该值
         */
    selectItem(i, item) {
      const vm = this
      if (i < 0 || i >= this.scrollerData.length) return
      if (item) {
        this.selectLabel = true
        this.disableTip = true
        this.balanceX = false // 还原translateX的动画效果，在请求下一段时，取消了动画效果
      }
      this.scrollFileList(i) // 滚动列表
      this.selectedItem = item || this.scrollerData[i]
      this.selectedItem.totalLen = this.totalLen
      // console.log('look here -selectItem', this.selectedItem)
      this.debounce(() => {
        vm.$emit('getSelectedData', vm.selectedItem) // emit对应数据给外层
      })
      // 问题：在移动时，tip不跟随移动，elementUi tip定位问题
      // 当点击小框移动时，取消tip，这块暂时这么处理，未来可考虑重新写tip组件
      setTimeout(() => {
        this.disableTip = false
      }, 1000)
    },
    /**
         * 防抖，在一定时间内只能操作一次
         */
    debounce(fn, delay = 400) {
      const vm = this
      // console.log('call', this.timer)
      clearTimeout(this.timer) // 防止快速点击
      this.timer = setTimeout(() => {
        // console.log('real call', this.timer)
        fn.call(vm)
      }, delay)
    },
    /**
         * 计算点击选中时，列表移动距离
         */
    calcTranslateX(selectedInx) {
      const FRAME_WIDTH = this.frameConfig.frameWidth + this.frameConfig.frameSpaceEach // 120+12
      const middleFrameIndex = this.getMiddleFramePos()
      const size = this.scrollerData.length
      const restNum = size - selectedInx
      let translateX = 0
      if (selectedInx <= middleFrameIndex - 1) { // 位于半屏之前，不需滚动
        translateX = 0
      } else if (restNum <= middleFrameIndex) { // 位于不足半屏之后，滚动到底
        const moveTo = selectedInx - this.frameNum + restNum
        translateX = (this.hasNext ? moveTo + 1 : moveTo) * -FRAME_WIDTH
      } else { // 位于首半屏和末半屏之间
        translateX = (selectedInx - (middleFrameIndex - 1)) * -FRAME_WIDTH // 当前位置移到首位，再往后移半屏，就定在中间了
      }
      this.translateX = translateX
      // console.log('transX', this.translateX)
    },
    /**
         * 计算计算点击选中时，startIndex和endIndex
         */
    calcStartEndIndex(selectedInx) {
      const size = this.scrollerData.length
      // if (selectedInx < 0 && selectedInx >= size) return [0, this.frameNum -1];
      const middleFrameIndex = this.getMiddleFramePos()
      let startInx = 0
      let endInx = 0
      const restNum = size - selectedInx
      if (this.totalLen <= this.frameNum) {
        startInx = 0
        endInx = startInx + (this.frameNum - 1)
      } else if (restNum <= middleFrameIndex) {
        endInx = size - 1
        startInx = endInx - (this.frameNum - 1)
        // startInx = selectedInx - (this.frameNum - restNum)
        // endInx = startInx + (this.frameNum - 1)
      } else {
        startInx = selectedInx - (middleFrameIndex - 1)
        endInx = startInx + (this.frameNum - 1)
      }
      // 限制startIndex和endIndex范围
      if (startInx <= 0) {
        startInx = 0
        endInx = startInx + (this.frameNum - 1)
      }
      if (endInx >= size) {
        endInx = size - 1
        startInx = endInx - (this.frameNum - 1)
      }
      [this.startIndex, this.endIndex] = [startInx, endInx]
      // console.log('calc start end-', [this.startIndex, this.endIndex])
    },
    /**
         * 滚动数据区域
         * @param {Number} curIndex 当前选中文件的相对index
         * @param {Boolean} focusOn 当前列表中，是否有选中的数据
         */
    scrollFileList(curIndex, focusOn = true) {
      this.curIndex = focusOn ? curIndex : -1 // 当前列表中，选中数据的相对index
      const newIndex = focusOn ? this.curIndex : this.curFileIndex // 要是当前列表没有选中，取数据(fileListInfo)外层的fileindex为当前定位
      this.calcStartEndIndex(newIndex)
      // if (this.totalLen <= this.frameNum) {
      //     this.startIndex = 0;
      //     this.endIndex = this.startIndex + this.frameNum - 1
      // } else if (restNum > 0 && restNum <= middleFrameIndex) {
      //     this.startIndex = curIndex - (this.frameNum - restNum);
      //     this.endIndex = this.startIndex + this.frameNum - 1 >= size ? size - 1 : this.startIndex + this.frameNum - 1;
      // } else {
      //     this.startIndex = newIndex - (middleFrameIndex - 1) <= 0 ? 0 : newIndex - (middleFrameIndex - 1);
      //     this.endIndex = this.startIndex + this.frameNum - 1 >= size ? size - 1 : this.startIndex + this.frameNum - 1;
      // }
      // console.log('scrollList index = ', this.startIndex, this.endIndex, this.curIndex, curIndex)
      this.$nextTick(() => {
        this.calcTranslateX(this.curIndex)
      })
      // this.$nextTick(() => {
      //     if (curIndex <= middleFrameIndex - 1) {
      //         this.translateX = 0; //this.hasPre ? FRAME_WIDTH : 0;
      //     } else if (restNum > 0 && restNum <= middleFrameIndex) {
      //         this.translateX = (this.hasNext ? curIndex - (this.frameNum - restNum - 1) : curIndex - (this.frameNum - restNum)) * -FRAME_WIDTH
      //     } else {
      //         this.translateX = -(curIndex - (middleFrameIndex - 1)) * FRAME_WIDTH;
      //     }
      // })
    },
    /**
         * 获取可视区中间小框下标
         * @returns {Number} middleFrameIndex
         */
    getMiddleFramePos() {
      let middleFrameIndex
      if (+this.frameNum % 2 === 1) { // 文件列表的小框数量为奇数
        middleFrameIndex = Math.ceil(+this.frameNum / 2)
      } else { // 偶数
        middleFrameIndex = +this.frameNum / 2
      }
      return middleFrameIndex
    },
    /**
         * 切换文件类型时触发
         * 在新的数据中，如果找到当前预览的数据，则还预览当前
         * 如果在新的数据中，如果没有找到，则跳转到新数据中的第一个
         */
    fileTypeChange(data) {
      const fileList = data.content || []
      if (fileList.length <= 0) return
      const curRelativeIndex = this.findInLoop(fileList, 'fileindex', data.fileindex)
      const selectdata = fileList[(curRelativeIndex >= 0 ? curRelativeIndex : 0)]
      selectdata.totalLen = data.content.length
      this.$emit('getSelectedData', selectdata)
    },
    /**
         * 获取分段请求的数据
         */
    getRangeData(res, req) {
      if (res.status === 200) {
        const { data } = res
        // 在隐藏底部列表的时候，切换类型
        if (JSON.stringify(this.fileListInfo) !== '{}' && data.filetype !== this.fileListInfo.filetype && !this.isShow) {
          this.fileTypeChange(data)
        }
        this.isLoadSuc = true
        this.fileListInfo = data
        this.loadData = false
        this.selectLabel = false
        this.direction = ''
      } else if (res.status.toString().indexOf('50') >= 0) {
        this.isLoadFail = true
        this.isLoadSuc = false
      } else if (res.status === 404) { // 当请求的neid被删时，请求前/后一个
        const lastReq = req || {} // request params
        const fileList = this.scrollerData || []
        const reqNeid = this.isDelivery ? lastReq.neid_chose : lastReq.neid
        const pos = this.findInLoop(fileList, 'neid', reqNeid)
        if (pos < 0) { // 没有上次的数据
          this.isLoadFail = true
          this.isLoadSuc = false
          return
        }
        const reqParamParsed = { ...this.reqParam } // reqParam的修饰,外链里和预览里不同
        const reqItem = this.scrollerData[pos >= 25 ? pos - 1 : pos + 1] || {}
        this.decorateReqParam(reqParamParsed, reqItem) // 修改请求参数
        this.$emit('load', { reqParam: reqParamParsed, getRangeData: this.getRangeData, selectedItem: this.selectedItem })
      } else {
        this.isLoadFail = true
        this.isLoadSuc = false
      }
    },
    /**
         * 点击刷新后，重新获取文件列表
         */
    reloadFileList() {
      // loading
      this.isLoadSuc = false
      this.isLoadFail = false
      const { reqParam, getRangeData } = this
      this.$emit('load', { reqParam, getRangeData })
    },
    /**
         * 获取文件的title
         */
    getTitle(val) {
      const path = val.split('/')
      const len = path.length
      return path[len - 1]
    },
    /**
         * 加载当前屏的图片
         */
    reqPicUrl(end) {
      this.$nextTick(() => {
        const allPic = this.$refs.scrollerContentBoxPic
        if (!allPic) return
        const onScreenPic = isNaN(end) ? allPic : allPic.slice(0, end)
        onScreenPic.forEach((item, i) => {
          // if (item.src.indexOf('preview_router') > -1) return;
         // if (item.dataset.loaded) return
          if (item.dataset.src) {
            item.src = item.dataset.src
            item.dataset.loaded = true // 标志data-src被加载到src了
          }
        })
      })
    },
    /**
         * 图片加载成功
         */
    getPicSuc(e) {
      // 没有加载图片的时候，不用添加poster-image; 因为默认图片也会走getPicSuc方法
      if (e.target && e.target.dataset && !e.target.dataset.loaded) return
      const { src } = e.target
      if (this.isDelivery) { // 外链图片请求成功后
        if (e.target && e.target.dataset && e.target.dataset.failed) { // 加载失败后的图片
          e.target.classList.remove('poster-image')
        } else { // 加载成功
          e.target.classList.add('poster-image')
        }
        return
      }
      if (src.indexOf('preview_router') > -1) {
        // if (e.target && e.target.dataset && e.target.dataset.failed) {
        //   e.target.classList.remove('poster-image')
        // } else {
          e.target.classList.add('poster-image')
        // }
      }
    },
    /**
         * 图片加载失败
         */
    getPicFail(item, e) {
      const { src } = e.target
      e.target.dataset.failed = true // 加载失败标识
      if (this.isDelivery) { // 外链图片报错后
        if (item.mime_type.indexOf('image') > -1) {
          e.target.src = picSrc
        }
        return
      }
      if (src.indexOf('preview_router') > -1) { // 预览图片报错后
        if (item.mime_type.indexOf('image') > -1) {
          e.target.src = picSrc
          e.target.classList.remove('poster-image')
        }
      }
    },
    /**
         * 获取当前的文件后缀，以展示不同略缩图
         */
    getFileIcon(item) {
      return Util.typeIcon(item.mime_type.split('.').pop())
    },
    /**
         * 获取图片略缩图地址
         */
    getPicRouter(data) {
      if (this.isDelivery) {
        const PICQUERY = {
          width: 120, // width和height传给后端，后端从一群压缩比中选出你想要的那个
          height: 70,
        }
        const pathRail = `&width=${PICQUERY.width}&height=${PICQUERY.height}`
        return data.preview_url + pathRail
      }
      const standardPicBase = `/v2/preview_router?type=pic&root=databox&interface_version=2020&S=${window.store.getters.S}`
      const params = {
        path: data.path,
        path_type: data.path_type,
        from: data.from || '',
        preview_agent: 'thumb',
        neid: data.neid,
        hash: data.hash,
        rev: data.rev,
        width: 120, // width和height传给后端，后端从一群压缩比中选出你想要的那个
        height: 70,
      }
      return standardPicBase + this.joinQueryData(params)
    },
    /**
         * 拼接query到url，可抽出来
         */
    joinQueryData(qryData) {
      const qryArr = ['']
      for (const key in qryData) {
        if (Object.prototype.hasOwnProperty.call(qryData, key)) {
          qryArr.push(`${key}=${encodeURIComponent(qryData[key])}`)
        }
      }
      return qryArr.join('&')
    },
    /**
         * 循环找到想要的数据
         */
    findInLoop(data = [], key, condition) {
      let pos = -1
      for (let i = 0; i < data.length; i++) {
        // console.log(data[i], data[i][key], condition)
        if (data[i][key] == condition) {
          pos = i
          break
        }
      }
      return pos
    },
    /**
         * 修饰底部的请求参， 外链是一种，预览是一种
         */
    decorateReqParam(reqParamParsed, reqParam) {
      if (this.isDelivery) {
        reqParamParsed.neid_chose = reqParam.neid
      } else {
        reqParamParsed.neid = reqParam.neid
      }
    },
  },
}
</script>
<style lang="less">
.preview-footer-scroller{
  width: 100%;
  height: 144px;
  display: inline-block;
  background: #F6F7FA;
  overflow: hidden;
  position: relative; // 用于scroller-section的父级定位
  .preview-control{
    width: 32px;
    height: 100%;
    line-height: 144px;
    text-align: center;
    cursor: pointer;
  }
  .preview-pre{
    float: left;
  }
  .preview-next{
    float: right;
  }
  .item-icon{
    width: 24px;
    height: 24px;
    padding: 4px;
    display: inline-block;
    border-radius: 2px;
    vertical-align: middle;
    &:hover{
      background-color: #E8EBEF;
    }
    &:active{
      background-color: #C1C7CD;
    }
  }
  .scroller-section{
    text-align: center;
    margin: 12px auto;
    white-space: nowrap;
    transform: width .4s ease;
    overflow: hidden;
    position: absolute; // 不然加了animation后，展开收缩右侧，会有一定空白，用定位解决
  }
  .scroller-tip{
    width: 100%;
    height: 100%;
    text-align: center;
    position: relative;
    font-size: 14px;
    color: #282E3D;
    letter-spacing: 0;
    .error-tip{
      display: inline-block;
      width: 460px;
      height: 20px;
      line-height: 20px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: -10px;
      margin-left: -230px;
      .refresh{
        padding-left: 4px;
        color: #0A64FA;
        cursor: pointer;
      }
    }
    .load-icon{
      display: inline-block;
      width: 20px;
      height: 20px;
      position: absolute;
      left: 50%;
      top: 50%;
      margin-top: -10px;
      margin-left: -10px;
      &:after{
        content: "";
        width: 20px;
        height: 20px;
        vertical-align: middle;
        display: inline-block;
        background: url(./images/blue-loading.gif) no-repeat center;
        background-size: 100%;
      }
    }
  }
  // 滚动时的，动画效果
  .transition-move{
    transition: all 0.4s ease;
  }
  .scroller-content{
    height: 120px;
    .header{
      width: 120px;
      height: 120px;
      margin: 0 12px 0 0;
      border: 1px solid #E8EBEF;
      border-radius: 2px;
      background-color: #FFFFFF;
      box-sizing: border-box;
      display: inline-block;
      cursor: pointer;
      word-break: break-all;
      position: absolute;
      left: -132px;
      .header-loading{
        line-height: 120px;
        &:after{
          content: "";
          width: 20px;
          height: 20px;
          vertical-align: middle;
          display: inline-block;
          background: url(./images/blue-loading.gif) no-repeat center;
          background-size: 100%;
        }
      }
    }
    .footer{
      width: 120px;
      height: 120px;
      margin: 0 12px 0 0;
      border: 1px solid #E8EBEF;
      border-radius: 2px;
      background-color: #FFFFFF;
      box-sizing: border-box;
      display: inline-block;
      cursor: pointer;
      word-break: break-all;
      position: absolute;
      .footer-loading{
        line-height: 120px;
        &:after{
          content: "";
          width: 20px;
          height: 20px;
          vertical-align: middle;
          display: inline-block;
          background: url(./images/blue-loading.gif) no-repeat center;
          background-size: 100%;
        }
      }
    }
    .scroller-content-box{
      width: 120px;
      height: 120px;
      margin: 0 12px 0 0;
      border: 1px solid #E8EBEF;
      border-radius: 2px;
      background-color: #FFFFFF;
      box-sizing: border-box;
      display: inline-block;
      cursor: pointer;
      word-break: break-all;
      vertical-align: middle;
      .scroller-content-poster{
        width: 100%;
        height: 77px;
        display: block;
        .poster-icon{
          width: 40px;
          height: 40px;
          padding: 18.5px;
        }
        .poster-image{
          width: 100%;
          height: 100%;
          padding: 8px;
          box-sizing: border-box;
          display: inline-block;
        }
      }
      .scroller-content-title{
        width: 100%;
        height: 35px;
        line-height: 17.5px;
        word-break: break-word;
        white-space: pre-wrap;
        display: inline-block;
        padding: 0 8px;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
    .focusOn{
      border-color: #0A64FA;
    }
  }
}
</style>
